import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-white" data-id="element-77">
      {/* Geometric Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03] bg-grid-pattern pointer-events-none" data-id="element-78"></div>

      {/* Decorative Circles */}
      <div className="absolute top-20 right-0 -mr-20 w-96 h-96 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-79"></div>
      <div className="absolute top-40 left-0 -ml-20 w-96 h-96 bg-navy-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-81">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-navy-50 text-navy-900 text-sm font-medium mb-8 border border-navy-100" data-id="element-82">
          <span className="flex h-2 w-2 rounded-full bg-blue-500 mr-2" data-id="element-83"></span>
          UK's Premier Tech Agency
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-navy-900 tracking-tight mb-6 leading-tight" data-id="element-84">
          Digital Solutions That <br className="hidden md:block" data-id="element-85" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-navy-900 to-blue-600" data-id="element-86">
            Drive Results
          </span>
        </h1>

        <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-87">
          We transform businesses with cutting-edge web development, mobile
          apps, and strategic design. Partner with Tech Vero Solutions to
          elevate your digital presence.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-88">
          <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-semibold rounded-lg text-white bg-navy-900 hover:bg-navy-800 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-89">
            Get Your Free Quote
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-90" />
          </a>
          <a href="#services" className="inline-flex items-center justify-center px-8 py-4 border border-gray-200 text-base font-semibold rounded-lg text-navy-900 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow-md" data-id="element-91">
            View Our Services
            <ChevronRight className="ml-2 h-5 w-5 text-gray-400" data-id="element-92" />
          </a>
        </div>
      </div>
    </section>;
}